<template>
  <v-card color="white">
    <v-row>
      <v-col cols="12" lg="5">
        <b class="help-step" style="cursor:help;" @click="show_help($t('ProposalType.text'), $t('ProposalType.help'))">
          {{$t('ProposalType.text')}}
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                style="cursor:help;"
              >
                <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span>{{$t('ProposalType.help')}}</span>
          </v-tooltip>
        </b>

        <div class="input-container input-name">
          <v-select
            v-model="currentProposalType"
            :items="proposal_types"
            :error="errorProposalType"
            :rules="[rules.required]"
            item-text="name"
            item-value="id"
            outlined
            chips
            required
            @input="currentProposalType > 0 ? errorProposalType = false : errorProposalType = true"
          ></v-select>
        </div>
      </v-col>
      <v-col cols="12" lg="7" v-if="currentProposalType == 2">
        <b class="help-step" style="cursor:help;" @click="show_help($t('ProposalAgreement.text'), $t('ProposalAgreement.help'))">
          {{$t('ProposalAgreement.text')}}
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                style="cursor:help;"
              >
                <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span>{{$t('ProposalAgreement.help')}}</span>
          </v-tooltip>
        </b>

        <div class="input-container input-name" >
          <v-text-field
            color='#15336d'
            v-model="currentProposalAgreement"
            outlined
            :rules="[rules.required]"
            :error="errorProposalAgreement"
            @input="(!currentProposalAgreement || currentProposalAgreement.length == 0) && currentProposalType == 2 ? errorProposalAgreement = true : errorProposalAgreement = true"
            type="text"
            counter="200"
            maxLength="200"
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <b class="help-step" style="cursor:help;" @click="show_help($t('general-information.text'), $t('general-information.help'))">
          {{$t('general-information.text')}}
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                style="cursor:help;"
              >
                <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span>{{$t('general-information.help')}}</span>
          </v-tooltip>
        </b>

        <div class="input-container input-name">
          <v-text-field
            color='#15336d'
            v-model="currentName"
            outlined
            :rules="[rules.required]"
            :error="errorName"
            @input="currentName.length !== 0 ? errorName = false : errorName = true"
            type="text"
            counter="200"
            maxLength="200"
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <b class="help-step" style="cursor:help;" @click="show_help($t('proposalKeywords.text'), $t('proposalKeywords.help'))">
          {{$t('proposalKeywords.text')}}
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                style="cursor:help;"
              >
                <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span>{{$t('proposalKeywords.help')}}</span>
          </v-tooltip>
        </b>

        <div class="input-container input-name">
          <v-textarea
            v-model="currentKeywords"
            outlined
            :error="errorKeywords"
            :rules="[rules.required]"
            @input="currentKeywords.length !== 0 ? errorKeywords = false : errorKeywords = true"
            type="text"
            counter="100"
            maxLength="100"
            no-resize
            rows="1"
          ></v-textarea>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="6">
        <b class="help-step" style="cursor:help;" @click="show_help($t('research-topics.text'), $t('research-topics.help'))">
          {{$t('research-topics.text')}}
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                style="cursor:help;"
              >
                <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span>{{$t('research-topics.help')}}</span>
          </v-tooltip>
        </b>

        <div class="input-container input-name">
          <v-select
            v-model="currentScience"
            :items="GETTERS_REFERENCES('scientific_area')"
            :error="errorScience"
            :rules="[rules.required]"
            item-text="name"
            item-value="id"
            outlined
            chips
            required
            @input="currentScience.length !== 0 ? errorScience = false : errorScience = true"
          ></v-select>
        </div>
      </v-col>
      <v-col cols="12" lg="6">
        <b class="help-step" style="cursor:help;" @click="show_help($t('previous-step.text'), $t('previous-step.help'))">
          {{$t('previous-step.text')}}
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                style="cursor:help;"
              >
                <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span>{{$t('previous-step.help')}}</span>
          </v-tooltip>
        </b>
        <div class="input-container input-name">
          <v-select
            v-model="currentPrevious"
            :items="listApplications"
            item-text="name"
            item-value="id"
            outlined
            chips
            required
            multiple
          ></v-select>
        </div>
      </v-col>
    </v-row>

  </v-card>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'TypeStep',
  props: [
    'name', 'scientific_subjects','keywords',
    'previous_proposals', 'agreement_type', 'agreement_text'
    ],

  async beforeMount() {
    this.GETTERS_MY_PROPOSALS.data.forEach(item => {
      if (item.id !== Number(this.$route.params.id)) {
        this.listApplications.push({
          id: item.id,
          name: '№' + item.id + ' – ' + (item.name ? item.name: this.$t('untitled')) })
      }
    })
  },

  data() {
    return {
      listApplications: [],

      errorScience: false,
      errorName: false,
      errorKeywords: false,
      currentName: this.name,
      currentKeywords: this.keywords,
      currentPrevious: this.previous_proposals,
      currentScience: this.scientific_subjects,
      rules: {
        required: (value) => (value === null || value.length === 0) ? this.$t('required') : true,
      },
      currentProposalType: this.agreement_type,
      errorProposalType: false,
      currentProposalAgreement: this.agreement_text,
      errorProposalAgreement: false,
      proposal_types:[
        {id: 0, name : '--Выберите'},
        {id: 1, name : 'Общий конкурс'},
        {id: 2, name : 'Договорная'},
      ],
    };
  },

  computed: {
    ...mapGetters([
      'GETTERS_REFERENCES',
      'GETTERS_NEW_PROPOSAL_STEPPER_NEED_CHECK',
      'GETTERS_MY_PROPOSALS',
    ]),
  },

  watch: {
    'GETTERS_NEW_PROPOSAL_STEPPER_NEED_CHECK.step1'(val){
      if(val){
        var status = this.validateInputs()

        this.NEW_PROPOSAL_UPDATE_STEPPER_CHECK_STATUS({name: 'step1', value: status})
        this.NEW_PROPOSAL_UPDATE_STEPPER_NEED_CHECK({name: 'step1', value: false})
      }
    },

    async currentPrevious(val) {
      this.UPDATE_QUIZE({previous_proposals: val});
    },
    async currentScience(val) {
      this.UPDATE_QUIZE({scientific_subjects: val});
    },
    async currentName(val) {
      this.UPDATE_QUIZE({name: val});
    },
    async currentKeywords(val){
      this.UPDATE_QUIZE({keywords: val});
    },
    async currentProposalType(val){
      this.UPDATE_QUIZE({proposal_type: val});
    },
    async currentProposalAgreement(val){
      this.UPDATE_QUIZE({proposal_agreement: val});
    },

  },

  methods: {
    ...mapMutations([
      'UPDATE_QUIZE', 

      'NEW_PROPOSAL_UPDATE_STEPPER_CHECK_STATUS',
      'NEW_PROPOSAL_UPDATE_STEPPER_NEED_CHECK',
      'UPDATE_HELPER_DIALOG',
    ]),

    show_help(header = '', text = ''){
      this.UPDATE_HELPER_DIALOG({
        'show' : true,
        'helper_data': {
          'header': header,
          'text': text,
        }
      })
    },

    validateInputs() {
      var status = true
      if (this.currentName === null || this.currentName.length === 0){
        this.errorName = true
        status = false
      }
      if (this.currentScience === null || this.currentScience.length === 0){
        this.errorScience = true
        status = false
      }
      if (this.currentKeywords === null || this.currentKeywords.length === 0){
        this.errorKeywords = true
        status = false
      }
      if (this.currentProposalType === null || this.currentProposalType === 0){
        this.errorProposalType = true
        status = false
      }
      if ((this.currentProposalAgreement === null || this.currentProposalAgreement.length === 0) && this.currentProposalType == 2){
        this.errorProposalAgreement = true
        status = false
      }
      return status
    },
  },
};
</script>
<style scoped>

  .input-container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .input-container .v-input__slot 
  .mb-12.wrapper.v-card.v-sheet.theme--light.white{
    box-shadow: none;
  }

  .form-container {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 700px;
    width: 100%;
  }
  h4{
    color: #949494;
    letter-spacing: -0.015em;
    font-style: normal;
    font-weight: 500;
  }
  .name-block{
    padding-top:30px;
  }
  .help-step {
    font-size: 14px;
    color: #949494;
  }
</style>
